var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('settings-card',{attrs:{"config":_vm.config}},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.payApply}},[_vm._v("去查看")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }